import { CALL_API } from '../middleware/api'

import { fetchEnrolments } from './enrolments.js';
import { loadMember } from './member.js'

export const CART_FETCH_REQUEST = 'CART_FETCH_REQUEST'
export const CART_FETCH_SUCCESS = 'CART_FETCH_SUCCESS'
export const CART_FETCH_FAILURE = 'CART_FETCH_FAILURE'

export const CART_ADD_REQUEST = 'CART_ADD_REQUEST'
export const CART_ADD_SUCCESS = 'CART_ADD_SUCCESS'
export const CART_ADD_FAILURE = 'CART_ADD_FAILURE'

export const CART_DELETE_REQUEST = 'CART_DELETE_REQUEST'
export const CART_DELETE_SUCCESS = 'CART_DELETE_SUCCESS'
export const CART_DELETE_FAILURE = 'CART_DELETE_FAILURE'

export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE'

export const fetchCart = (forceRefresh = false) => (dispatch, getState) => {
	
	const cart = getState().cart;
	const now = Math.floor(Date.now() / 1000);
	if (!forceRefresh && cart && (cart.expires >= now || cart.submitting)) {
		return null
	}
	
	const user = getState().user;
	
	return dispatch({
		[CALL_API]: {
			types: [ CART_FETCH_REQUEST, CART_FETCH_SUCCESS, CART_FETCH_FAILURE ],
			endpoint: '/cart/',
			method: 'POST',
			params: {member_no: user.member_no},
			bad_response: 'Error fetching cart contents from U-MAS database'
		}
	})
}

export const addToCart = (course_code) => (dispatch, getState) => {
	const user = getState().user;
	
	return dispatch({
		[CALL_API]: {
			types: [ CART_ADD_REQUEST, CART_ADD_SUCCESS, CART_ADD_FAILURE ],
			endpoint: '/cart/',
			method: 'PUT',
			params: {
				course_code: course_code,
				member_no: user.member_no
			},
			bad_response: 'Error adding item to cart'
		}
	})
}

export const deleteFromCart = (course_code = false) => (dispatch, getState) => {
	const user = getState().user;
	
	const params = course_code ? {
		course_code: course_code,
		member_no: user.member_no
	} : {
		member_no: user.member_no
	}
	
	return dispatch({
		[CALL_API]: {
			types: [ CART_DELETE_REQUEST, CART_DELETE_SUCCESS, CART_DELETE_FAILURE ],
			endpoint: '/cart/',
			method: 'DELETE',
			params: params,
			bad_response: 'Error deleting item(s) from cart'
		}
	})
}

export const checkout = (termsAgreed = false) => (dispatch, getState) => {
	const user = getState().user;
	
	return dispatch({
		[CALL_API]: {
			types: [ CHECKOUT_REQUEST, CHECKOUT_SUCCESS, CHECKOUT_FAILURE ],
			endpoint: '/checkout/',
			method: 'PUT',
			params: {
				member_no: user.member_no,
				agreed_terms: termsAgreed
			},
			bad_response: 'Error checking out'
		}
	}).then(result => {
		dispatch(loadMember(true));
		dispatch(fetchEnrolments(null, null, true));
	})
}